import { forwardRef } from 'react';
import { styled } from '@mui/material/styles';
import { getPhotoConfig } from '../../config';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});

type CameraInputProps = {
  onFilesSelected: (files: File[]) => void;
  multiple?: boolean;
};

export const CameraInput = forwardRef<HTMLInputElement, CameraInputProps>(
  ({ onFilesSelected, multiple = true }, ref) => {
    const photoConfig = getPhotoConfig();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const files = e.target.files;
      if (files && files.length > 0) {
        onFilesSelected(Array.from(files));
      }
      if (e.target) {
        e.target.value = '';
      }
    };

    return (
      <VisuallyHiddenInput
        ref={ref}
        type="file"
        multiple={multiple}
        accept={photoConfig.validation.allowedMimeTypes.join(',')}
        onChange={handleChange}
      />
    );
  }
);

CameraInput.displayName = 'CameraInput';
